import axios from "axios";

const instance = axios.create({
    baseURL: "https://tobaku.explor.id/api"
});

export default instance;
